module.exports = __webpack_public_path__ + "images/shipping.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shipping.png
// module id = /S2x
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13